'use client'

import SideBarMenu from './menu';
import Logo from './logo';
import InvestModalProvider from '@/providers/invest-modal/provider';
import { useNavigate } from 'react-router-dom';
import { useUserStore } from '@/store/auth/store';

export default function SideBar() {
  const openSidebar = useUserStore((state) => state.openSidebar);
  const toggleSidebar = useUserStore((state) => state.toggleSidebar);
  const navigate = useNavigate();

  return (
    <div
      className={`${openSidebar ? "sidebar-opacity" : ""}`}
      onClick={(e) => {
        if (openSidebar) {
          e.stopPropagation();
          toggleSidebar();
        }
      }}
    >
      <nav className={`sidebar custom-scrollbar ${openSidebar ? "active" : ""}`}>
        <div className="sidebar-content">
          <div onClick={() => navigate('/')}>
            <Logo />
          </div>
          <div
            style={{
              width: '100%',
              height: '1px',
              backgroundColor: 'transparent',
            }}
          />
          <InvestModalProvider>
            <SideBarMenu />
          </InvestModalProvider>
        </div>
      </nav>
    </div>
  );
}
